import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { SignSignatureStatus } from "gql/graphql";
import Tag from "@/shared/data-display/tag";
import { useTranslations } from "use-intl";

export function SignSignatureStatusTag({
  status,
}: {
  status: SignSignatureStatus;
}) {
  const t = useTranslations("SignSignature");

  switch (status) {
    case SignSignatureStatus.Signed:
      return (
        <Tag
          data-testid={`sign-signature-status-${status}`}
          color={"success"}
          icon={<CheckCircleOutlined />}
        >
          {t(status)}
        </Tag>
      );

    case SignSignatureStatus.Rejected:
      return (
        <Tag
          data-testid={`sign-signature-status-${status}`}
          color={"error"}
          icon={<CloseCircleOutlined />}
        >
          {t(status)}
        </Tag>
      );

    default:
      return (
        <Tag
          data-testid={`sign-signature-status-${status}`}
          color={"processing"}
          icon={<SyncOutlined />}
        >
          {t(status)}
        </Tag>
      );
  }
}
